<div class="confirm-modal-popup">
    <span class="material-icons close-icon-modal position-absolute" (click)="closeDialog()">close</span>
    <img src="assets/images/check-icon.svg" alt="check-icon" class="modal-icon">
    <div class="modal-message">
        <p class="f-16 pb-0 mb-0">
            LYNK ID# <span class="green_text mx-1">{{data.lynk}}</span> load assigned successfully and job notification
            has been sent to {{data.postedBy.name}}.
        </p>
    </div>
    <div class="modal-actions">
        <button mat-button class="btn rounded_btn green_btn small_btn px-4 fw-400" (click)="closeDialog()">OK</button>
    </div>
</div>
